// oxlint-disable no-await-in-loop
import ky from "ky";
import queryString from "query-string";
import snakecaseKeys from "snakecase-keys";

import { apiUrls } from "../../urls";
import { getCsrfToken } from "../../utils/getcsrftoken";
import { wait } from "../../utils/wait";
import { assertApiResponse } from "../utils/assertapiresponse";

import { parseFlatsCreation, parseFlatsStatus } from "./structs";

export type CreateFlatsParams = {
    jemOriginTimeFrom: string;
    jemOriginTimeTo: string;
    mjmaFrom: number;
    mjmaTo: number;
    hypoDistFrom: number;
    hypoDistTo: number;
    useAcc: 0 | 1;
};

const kickFlatsCreate = async (params: Partial<CreateFlatsParams>) => {
    const body = (params) ?
        new URLSearchParams(queryString.stringify(snakecaseKeys(params), { arrayFormat: "comma" })) :
        undefined;

    const json = await ky
        .post(
            apiUrls["/flats/create"].post(),
            {
                body,
                headers: { "x-csrftoken": getCsrfToken() },
                credentials: "same-origin",
                mode: "same-origin",
                timeout: 30 * 1000,
            })
        .json();

    assertApiResponse(json);

    if (json.result.status) {
        return parseFlatsCreation(json.objects);
    } else {
        throw new Error(json.result.message);
    }
};

const kickFlatsStatus = async (jobId: string) => {
    const json = await ky
        .get(
            apiUrls["/flats/status/[jobId]"].get({ params: { jobId } }),
            { credentials: "same-origin", mode: "same-origin", throwHttpErrors: false })
        .json();

    assertApiResponse(json);

    if (json.result.status) {
        return parseFlatsStatus(json.objects);
    } else {
        throw new Error(json.result.message);
    }
};

/**
 * フラットファイルの作成を依頼し、その状況をyieldで返す。
 * ポーリング処理を非同期ジェネレーターで包んで抽象化したもの。
 * 何らかの終了状態になるまで値を返し続ける。
 *
 * @param params 検索パラメーター
 * @yields 作成状況
 * @returns 作成状況
 */
export async function* createFlats(params: Partial<CreateFlatsParams>) {
    const { jobId } = await kickFlatsCreate(params);

    while (true) {
        await wait(3000);
        const result = await kickFlatsStatus(jobId);
        yield result;

        if (["succeeded", "no_data", "failed", "not_found"].includes(result.status)) {
            break;
        }
    }
}
